/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './consumable-group.reducer';

export const ConsumableGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const consumableGroupEntity = useAppSelector(state => state.consumableGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consumableGroupDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.consumableGroup.detail.title">ConsumableGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.id">Id</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.category">Category</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.category}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.addedBy}</dd>
          <dt>
            <span id="deviceTypeName">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.deviceTypeName">Device Type Name</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.deviceTypeName}</dd>
          <dt>
            <span id="riskClass">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.riskClass">Risk Class</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.riskClass}</dd>
          <dt>
            <span id="generalIntendedUse">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.generalIntendedUse">General Intended Use</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.generalIntendedUse}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.active">Active</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.consumableGroup.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{consumableGroupEntity.microSec}</dd>
        </dl>
        <Button tag={Link} to="/consumable-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/consumable-group/${consumableGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsumableGroupDetail;
